module.exports = __webpack_public_path__ + "img/suitable.34d812bc.svg";